export default __webpack_public_path__ + "static/media/sv44_en_head_a1.e3caa0d1.mp3";